import { Sparkles, BadgeCheck, Bookmark, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import EventCard from "@/components/EventCard";
import CommunityCard from "@/components/CommunityCard";

export default function MatchResult({ result, onSave, onReset }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12" data-testid="matchmaker-result">
      <div className="bg-slate-900 rounded-2xl p-8 md:p-12 relative overflow-hidden">
        <div className="absolute -top-20 -right-20 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl" />
        <span className="inline-flex items-center gap-2 bg-emerald-500/15 border border-emerald-400/30 text-emerald-300 text-xs font-bold px-4 py-1.5 rounded-full">
          <Sparkles className="w-3.5 h-3.5" /> AI Personal Action Profile
        </span>
        <h1 data-testid="profile-title" className="font-heading font-black text-4xl sm:text-5xl text-white tracking-tight mt-4">{result.profile_title}</h1>
        <p className="text-emerald-300 font-bold mt-2">{result.profile_tagline}</p>
        <p className="text-slate-300 mt-4 max-w-2xl leading-relaxed">{result.profile_description}</p>
        <div className="flex flex-wrap gap-2 mt-6">
          {result.strengths.map((s) => (
            <span key={s} className="text-xs font-bold px-3 py-1.5 rounded-full bg-white/10 text-white border border-white/20">{s}</span>
          ))}
        </div>
        <div className="flex flex-wrap gap-3 mt-8">
          <Button data-testid="save-plan-btn" onClick={onSave} className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold">
            <Bookmark className="w-4 h-4 mr-2" /> Simpan Rencana Aksi
          </Button>
          <Button data-testid="retry-matchmaker-btn" onClick={onReset} variant="outline" className="rounded-full border-slate-600 bg-white/5 text-white hover:bg-white/15 hover:text-white font-bold">
            <RotateCcw className="w-4 h-4 mr-2" /> Ulangi Asesmen
          </Button>
        </div>
      </div>

      <h2 className="font-heading font-black text-2xl text-slate-900 tracking-tight mt-12 mb-2">3 Aksi Paling Cocok Untukmu</h2>
      <p className="text-slate-500 mb-6 text-sm">Klik "Ikuti Aksi" untuk Daftar Sekarang.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {result.events.map((e) => (
          <div key={e.id} className="space-y-2">
            <EventCard event={e} />
            <p className="text-xs text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-xl px-3 py-2 font-semibold">✦ {e.match_reason}</p>
          </div>
        ))}
      </div>

      <h2 className="font-heading font-black text-2xl text-slate-900 tracking-tight mt-12 mb-6 flex items-center gap-2">
        <BadgeCheck className="w-6 h-6 text-emerald-600" /> 2 Komunitas Terverifikasi Untukmu
      </h2>
      <div className="grid sm:grid-cols-2 gap-6">
        {result.communities.map((c) => (
          <div key={c.id} className="space-y-2">
            <CommunityCard community={c} />
            <p className="text-xs text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-xl px-3 py-2 font-semibold">✦ {c.match_reason}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
